import React from 'react';
import { EngineRenderers } from '../../../../../renderProps';
import PriceDetailsRoot from '../PriceDetails';

const PriceDetailsExtendedVariant: EngineRenderers['PriceDetails'] = props => {
	return <PriceDetailsRoot {...props} variant="extended-details" />;
};

export default PriceDetailsExtendedVariant;
